export default function signupDataStore() {
    return {
        clear: function() {
            this.user = null;
            this.invoice = null;
            this.account = null;
            this.payment = null;
            this.stripe = null;
            this.upgrade = null;
        },
        clearPaymentDetails: function() {
            this.payment = null;
            this.stripe = null;
            this.upgrade = null;
        },
        invoice: null,
        account: null,
        payment: null,
        stripe: null,
        upgrade: null
    };
}



// WEBPACK FOOTER //
// ./data/services/signup-data-store.js